import { Icon } from '@gitbook/spine-icons';
import { toast } from '@gitbook/spine-react';

import { NotificationFormattedTitle } from './NotificationFormattedTitle';
import { type NotificationData, useMagicBellEvent } from './notifications';
import { useOpenNotification } from './useOpenNotification';

/**
 * Hook to show new notifications to the user in a toast.
 */
export function useNotificationToasts() {
    const openNotification = useOpenNotification();

    useMagicBellEvent('notifications.new', (notification: NotificationData) => {
        toast('Notification', {
            icon: Icon.Bell,
            description: <NotificationFormattedTitle notification={notification} />,
            ...(notification.actionUrl
                ? {
                      action: {
                          label: 'Open',
                          onClick: () => {
                              openNotification(notification);
                          },
                      },
                  }
                : {}),
        });
    });
}
